"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMParameterBytecodeCompiler = void 0;
const inversify_1 = require("inversify");
const IVMCompilerUtils_1 = require("../../../interfaces/vm-transformers/IVMCompilerUtils");
const IVMScopeManager_1 = require("../../../interfaces/vm-transformers/IVMScopeManager");
const ServiceIdentifiers_1 = require("../../../container/ServiceIdentifiers");
const NodeGuards_1 = require("../../../node/NodeGuards");
let VMParameterBytecodeCompiler = class VMParameterBytecodeCompiler {
    constructor(vmCompilerUtils, scopeManager) {
        this.vmCompilerUtils = vmCompilerUtils;
        this.scopeManager = scopeManager;
    }
    compileParameters(params, context) {
        var _a, _b;
        let restParamName = null;
        let restParamPattern = null;
        let regularParamCount = 0;
        const defaultParams = [];
        const destructuringParams = [];
        if (params) {
            params.forEach((param, index) => {
                if (!param) {
                    return;
                }
                if (NodeGuards_1.NodeGuards.isIdentifierNode(param)) {
                    context.parameters.set(param.name, index);
                    regularParamCount++;
                }
                else if (NodeGuards_1.NodeGuards.isAssignmentPatternNode(param)) {
                    if (NodeGuards_1.NodeGuards.isIdentifierNode(param.left)) {
                        context.parameters.set(param.left.name, index);
                        regularParamCount++;
                        defaultParams.push({
                            paramIndex: index,
                            defaultExpr: param.right
                        });
                    }
                    else if (NodeGuards_1.NodeGuards.isArrayPatternNode(param.left) ||
                        NodeGuards_1.NodeGuards.isObjectPatternNode(param.left)) {
                        regularParamCount++;
                        destructuringParams.push({
                            paramIndex: index,
                            pattern: param.left
                        });
                        defaultParams.push({
                            paramIndex: index,
                            defaultExpr: param.right
                        });
                    }
                }
                else if (NodeGuards_1.NodeGuards.isRestElementNode(param)) {
                    if (NodeGuards_1.NodeGuards.isIdentifierNode(param.argument)) {
                        restParamName = param.argument.name;
                        const localIndex = context.localVariables.size;
                        context.localVariables.set(restParamName, localIndex);
                    }
                    else if (NodeGuards_1.NodeGuards.isArrayPatternNode(param.argument) ||
                        NodeGuards_1.NodeGuards.isObjectPatternNode(param.argument)) {
                        restParamPattern = param.argument;
                        restParamName = '__rest_temp__';
                        const localIndex = context.localVariables.size;
                        context.localVariables.set(restParamName, localIndex);
                    }
                }
                else if (NodeGuards_1.NodeGuards.isArrayPatternNode(param) || NodeGuards_1.NodeGuards.isObjectPatternNode(param)) {
                    regularParamCount++;
                    destructuringParams.push({
                        paramIndex: index,
                        pattern: param
                    });
                }
            });
        }
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        for (const [paramName, paramIndex] of context.parameters) {
            if (context.envVars.has(paramName)) {
                builder.loadArg(paramIndex);
                builder.storeToEnvByName(paramName);
                builder.pop();
            }
        }
        for (const { paramIndex, defaultExpr } of defaultParams) {
            builder.loadArg(paramIndex);
            const skipDefault = builder.emitUndefinedCheck();
            builder.pop();
            const remainingParams = [];
            for (const [pName, pIndex] of context.parameters) {
                if (pIndex >= paramIndex) {
                    remainingParams.push(pName);
                }
            }
            this.scopeManager.enterParametersTDZ(context, remainingParams);
            (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(defaultExpr);
            builder.storeArg(paramIndex);
            let paramName = null;
            for (const [name, index] of context.parameters) {
                if (index === paramIndex) {
                    paramName = name;
                    break;
                }
            }
            if (paramName && context.envVars.has(paramName)) {
                builder.loadArg(paramIndex);
                builder.storeToEnvByName(paramName);
                builder.pop();
            }
            const jumpToEnd = builder.jump();
            skipDefault.patchToHere();
            builder.pop();
            jumpToEnd.patchToHere();
        }
        this.scopeManager.clearParametersTDZ(context);
        if (restParamName !== null) {
            this.vmCompilerUtils.emitRestParameterHandling(restParamName, restParamPattern, regularParamCount, context);
        }
        for (const { paramIndex, pattern } of destructuringParams) {
            builder.loadArg(paramIndex);
            (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.destructuring(pattern, false);
        }
        return regularParamCount;
    }
};
exports.VMParameterBytecodeCompiler = VMParameterBytecodeCompiler;
exports.VMParameterBytecodeCompiler = VMParameterBytecodeCompiler = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMCompilerUtils)),
    __param(1, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMScopeManager)),
    __metadata("design:paramtypes", [typeof (_a = typeof IVMCompilerUtils_1.IVMCompilerUtils !== "undefined" && IVMCompilerUtils_1.IVMCompilerUtils) === "function" ? _a : Object, typeof (_b = typeof IVMScopeManager_1.IVMScopeManager !== "undefined" && IVMScopeManager_1.IVMScopeManager) === "function" ? _b : Object])
], VMParameterBytecodeCompiler);
